import React, { useState } from 'react';
import { Lock, ShieldCheck, LogOut } from 'lucide-react';
import { Button } from '../../components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '../../components/ui/tooltip';
import { useAuthStore, useIsAdmin } from './authStore';
import { UnlockModal } from './UnlockModal';
import { cn } from '../../lib/utils';

export function AuthBadge() {
  const [unlockModalOpen, setUnlockModalOpen] = useState(false);
  const isAdmin = useIsAdmin();
  const { lock, loading } = useAuthStore();

  const handleLock = async () => {
    await lock();
  };

  if (isAdmin) {
    return (
      <>
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-1.5 rounded-full bg-success/10 px-3 py-1.5 text-success">
            <ShieldCheck className="h-4 w-4" />
            <span className="text-sm font-medium">管理员</span>
          </div>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                onClick={handleLock}
                disabled={loading}
                className="h-8 w-8"
              >
                <LogOut className="h-4 w-4" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>退出管理员模式</p>
            </TooltipContent>
          </Tooltip>
        </div>
        <UnlockModal open={unlockModalOpen} onOpenChange={setUnlockModalOpen} />
      </>
    );
  }

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="outline"
            size="sm"
            onClick={() => setUnlockModalOpen(true)}
            className={cn(
              "gap-1.5 transition-all",
              "hover:border-primary hover:text-primary"
            )}
          >
            <Lock className="h-4 w-4" />
            <span>浏览模式</span>
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>点击解锁编辑功能</p>
        </TooltipContent>
      </Tooltip>
      <UnlockModal open={unlockModalOpen} onOpenChange={setUnlockModalOpen} />
    </>
  );
}
